import { Shield, Clock, Heart, Award } from 'lucide-react';

export const TrustBadges = () => {
  const badges = [
    { icon: Shield, text: 'Alle Kassen', subtext: 'AOK, TK, Barmer & mehr' },
    { icon: Clock, text: '24/7', subtext: 'Immer erreichbar' },
    { icon: Heart, text: '100+', subtext: 'Betreute Familien' },
    { icon: Award, text: '4.9 ★', subtext: 'Bewertung' },
  ];

  return (
    <section className="py-6 bg-white border-y border-[#e2e8f0]">
      <div className="container-custom">
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
          {badges.map((badge, index) => (
            <div key={index} className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#1A52D8]/10 to-[#23D3D3]/10 flex items-center justify-center">
                <badge.icon className="w-5 h-5 text-[#1A52D8]" />
              </div>
              <div>
                <p className="font-bold text-[#1e293b] text-sm">{badge.text}</p>
                <p className="text-xs text-[#64748b]">{badge.subtext}</p>
              </div>
            </div>
          ))}
        </div>
        
        {/* Kassenlogos */}
        <div className="mt-6 pt-6 border-t border-[#e2e8f0]">
          <p className="text-center text-xs text-[#94a3b8] mb-4">Abrechnung mit allen Pflegekassen</p>
          <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10 opacity-60 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-500">
            <span className="text-sm font-bold text-[#64748b]">AOK</span>
            <span className="text-sm font-bold text-[#64748b]">TK</span>
            <span className="text-sm font-bold text-[#64748b]">BARMER</span>
            <span className="text-sm font-bold text-[#64748b]">DAK</span>
            <span className="text-sm font-bold text-[#64748b]">IKK</span>
            <span className="text-sm font-bold text-[#64748b]">KKH</span>
            <span className="text-sm font-bold text-[#64748b]">+ alle weiteren</span>
          </div>
        </div>
      </div>
    </section>
  );
};
